import { useTranslation } from 'react-i18next';

import { SewBillingCycleExport } from '@/backoffice/features/data-exports/sew-billing-cycle-export/sew-billing-cycle-export';
import { useLazySewSapExportQuery } from '@/backoffice/redux/api/billing-backoffice/billing-backoffice-api';
import { BillingSewRegionEnum } from '@/backoffice/types/types.generated';
import { SEW_BILLING_REGION_OPTIONS } from '@/reseller/sew/billing-regions/billing-regions.constants';

export const SewSapExport = () => {
  const { t } = useTranslation();
  const [getFile] = useLazySewSapExportQuery();

  const fetchExport = async (billingCycleReferenceTs: number, region = '') => {
    const response = await getFile({
      billingCycleReferenceTs,
      region: region as BillingSewRegionEnum,
    }).unwrap();
    return response?.sewSapExport;
  };

  return (
    <SewBillingCycleExport
      title={t('backoffice:sew.data_exports.sap.title')}
      description={t('backoffice:sew.data_exports.sap.description')}
      loaderText={t('backoffice:sew.data_exports.sap.loader_text')}
      baseFileNamePrefix="sew_sap_export"
      regionOptions={SEW_BILLING_REGION_OPTIONS}
      fetchExport={fetchExport}
    />
  );
};
